import gql from 'graphql-tag';

export const LISTING_ANALYTICS_ECOMMERCE = gql`
    fragment LISTING_ANALYTICS_ECOMMERCE on ListingAnalyticsEcommerce {
        brand
        category
        id
        name
        price
        quantity
        variant
    }
`;

export const LISTING_ANALYTICS_TAXONOMY = gql`
    fragment LISTING_ANALYTICS_TAXONOMY on ListingAnalyticsTaxonomy {
        acorn
        acornType
        areaName
        bedsMax
        bedsMin
        branchId
        branchLogoUrl
        branchName
        brandName
        chainFree
        companyId
        countryCode
        countyAreaName
        currencyCode
        displayAddress
        furnishedState
        groupId
        hasEpc
        hasFloorplan
        incode
        isRetirementHome
        isSharedOwnership
        listingCondition
        listingId
        listingsCategory
        listingStatus
        location
        memberType
        numBaths
        numBeds
        numImages
        numRecepts
        outcode
        postalArea
        postTownName
        priceActual
        price
        priceMax
        priceMin
        priceQualifier
        propertyHighlight
        propertyType
        regionName
        section
        sizeSqFeet
        tenure
        zindex
    }
`;
